/* eslint-disable react/prop-types */
import React from 'react'
import { withTranslation } from 'react-i18next'
import logo from '../../../assets/images/logos/OP36_clean_icon_dark.png'
import './DrillPreviewCard.scss'
import PropTypes from 'prop-types'

class DrillPreviewCard extends React.Component {
  state = {
    hovering: false,
  }
  // eslint-disable-next-line complexity
  render() {
    const {
      t,
      drill,
      triggerDetailModal,
      taskIndex,
      blockIndex,
      moveTask,
    } = this.props
    const isArchived = drill.is_archived || drill.isArchived
    const isCoachActivity = drill.is_coach_activity || drill.isCoachActivity
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div
        id='DrillPreviewCard'
        onMouseEnter={this._startHover}
        onMouseLeave={this._endHover}
        onClick={
          drill.is_archived || drill.isArchived ? () => false : () => triggerDetailModal(drill.id)
        }
        style={
          drill.is_archived || drill.isArchived
            ? { background: '#c0c0c0', cursor: 'not-allowed' }
            : {}
        }
      >
        {this.props.active && this.state.hovering ? (
          <div className='grey-out'>
            <div className='task-nav-buttons-container'>
              <i
                className='fa fa-sort-asc'
                aria-hidden='true'
                onClick={e => moveTask(e, -1, taskIndex, blockIndex)}
              />
              <i
                className='fa fa-sort-desc'
                aria-hidden='true'
                onClick={e => moveTask(e, 1, taskIndex, blockIndex)}
              />
            </div>
            <div className='task-play-button-container'>
              {isArchived ? (
                <p className='archived-text'>
                  {t('lessonPlans.drillPreviewCard.archivedText', {
                    type: isCoachActivity
                      ? t('lessonPlans.drillPreviewCard.activity')
                      : t('lessonPlans.drillPreviewCard.drill'),
                  })}
                </p>
              ) : (
                <i className='fa fa-play' aria-hidden='true' />
              )}
            </div>
            <div className='task-delete-container'>
              <i
                className='fa fa-trash-o'
                aria-hidden='true'
                onClick={e =>
                  this.props.removeActive(
                    e,
                    this.props.blockIndex,
                    this.props.taskIndex
                  )
                }
              />
            </div>
          </div>
        ) : null}
        <div
          className='drill-card-photo'
          style={
            drill.is_archived || drill.isArchived
              ? {
                backgroundImage: 'linear-gradient(to bottom right, rgba(255,255,255,0.8), rgba(0,0,0,0.5),' +
                'rgba(255,255,255,0.8),rgba(0,0,0,0.5),rgba(255,255,255,0.8),rgba(0,0,0,0.5),rgba(255,255,255,0.8),' +
                'rgba(0,0,0,0.5),rgba(255,255,255,0.8),rgba(0,0,0,0.5)),' +
                `url(${drill.photos.length > 0 ? drill.photos[0].file_url || drill.photos[0].fileUrl : logo})`,
              }
              : {
                backgroundImage: `url(${drill.photos.length > 0 ? drill.photos[0].file_url || drill.photos[0].fileUrl : logo})`,
              }
          }
        />
        <div className={'drill-card-info-container'}>
          <p
            className='drill-card-title'
            style={isArchived ? { color: '#777' } : {}}
          >
            {isArchived ? t('lessonPlans.drillPreviewCard.archivedPrefix') + drill.title : drill.title}
          </p>
          <p className='drill-card-description'>{drill.description}</p>
          <div className='drill-card-tag-container'>
            {drill.tags.map((tag, index) => {
              if (index < 2) {
                return (
                  <p
                    key={index}
                    className='drill-card-tag-bubble'
                    style={isArchived ? { color: '#ddd' } : {}}
                  >
                    {tag.name}
                  </p>
                )
              } else if (index === 2) {
                return (
                  <p key={index} className='more-tags-indicator'>{t('lessonPlans.drillPreviewCard.moreSkills', { count: drill.tags.length - 2 })}</p>
                )
              }
            })}
          </div>
        </div>
        {this.props.picker && (
          <i className='fa fa-play-circle-o' aria-hidden='true' />
        )}
      </div>
    )
  }

  _startHover = () => {
    this.setState({ hovering: true })
  }

  _endHover = () => {
    this.setState({ hovering: false })
  }
}

DrillPreviewCard.propTypes = {
  t: PropTypes.func,
  drill: PropTypes.shape({
    id: PropTypes.number,
    is_archived: PropTypes.bool,
    isArchived: PropTypes.bool,
    is_coach_activity: PropTypes.bool,
    isCoachActivity: PropTypes.bool,
    photos: PropTypes.array,
    title: PropTypes.string,
  }),
}

export default withTranslation()(DrillPreviewCard)
